/**
 * Vuex "userauth" module (registered as `auth` in the root store).
 *
 * Aggregates authentication and signup/onboarding state: the current user
 * profile and auth status/error (store.js), the actions that drive
 * login/signup/logout, phone-SMS verification, 2FA, and X (Twitter)/SIWF
 * social-auth flows (operations.js), thin getters over that state
 * (selectors.js), and the mutations that write it (updates.js).
 */
import state from "./store";
import mutations from "./updates";
import getters from "./selectors";
import actions from "./operations";

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
